/*
 * Filename: field-dynamicSource-array.model.ts
 * Error store: This file represents the model for templates that will be displayed on homepage.
 */

import { types, ModelInstanceTypeProps, ModelProperties } from 'mobx-state-tree';


export const FieldDynamicSourceData = types.model({
    FieldDynamicSourceData: types.optional(types.frozen(), {}),
    selectedDynamicSourceValue: types.optional(types.frozen(), {})
}).actions((self: ModelInstanceTypeProps<ModelProperties>) => ({

    deleteDynamicSource(objectName: string, deleteRuleObject: any) {
        let existingDynamicSourceObject = { ...self.FieldDynamicSourceData };
        delete existingDynamicSourceObject[objectName];
        self.FieldDynamicSourceData = existingDynamicSourceObject;

    },
    addDynamicSource(objectName: string, dynamicSource: any) {
            if (self.FieldDynamicSourceData.hasOwnProperty(objectName)) {
                const fieldDynamicSourceData = { ...self.FieldDynamicSourceData };
                delete fieldDynamicSourceData[objectName];
                self.FieldDynamicSourceData = { ...fieldDynamicSourceData, [objectName]: dynamicSource[objectName] };
            }
            else {
                let fieldDynamicSourceData = { ...self.FieldDynamicSourceData };
                fieldDynamicSourceData = { ...fieldDynamicSourceData, [objectName]: dynamicSource[objectName] };
                self.FieldDynamicSourceData = fieldDynamicSourceData;
            }

    },
    setSelectedPDynamicSourceValue(objectName:string){
        if(self.FieldDynamicSourceData.hasOwnProperty(objectName)){
            const value = self.FieldDynamicSourceData[objectName];
            self.selectedDynamicSourceValue = value;
        } else{
            self.selectedDynamicSourceValue = {}
        }
    },
    setDeployedDynamicSource(dynamicSource:any){
        self.FieldDynamicSourceData= dynamicSource;
    }
}));
